import TextField from '../../../../sharedComponent/TextField/TextField'
import deleteIcon from '../../../../../_metronic/images/Trashdelete.svg'
import CustomButton from '../../../../sharedComponent/CustomButton'
const AgentLeader = ({formik}: any) => {
  return (
    <div className='w-100'>
      {formik.values.agentLeaders.map((agentLeader: any, index: number) => (
        <div className='d-flex align-items-center '>
          <TextField
            fieldName={`agentLeaders[${index}].leaderName`}
            formik={formik}
            fieldTitle='Agent Leader name'
            filedTitleMandatory={true}
            className='me-2'
            outerdivClassName='me-3 mb-2'
            placeHolder='Enter Agent Leader Name'
          />
          <TextField
            fieldName={`agentLeaders[${index}].leaderCode`}
            formik={formik}
            fieldTitle='Agent Leader Code'
            filedTitleMandatory={true}
            placeHolder='Enter Agent Leader Code'
          />

          <img
            src={deleteIcon}
            onClick={() => {
              formik.setValues({
                ...formik.values,
                agentLeaders: [...formik.values.agentLeaders.toSpliced(index, 1)],
              })
              formik.setTouched({
                ...formik.touched,
                agentLeaders: formik.touched.agentLeaders?.filter(
                  (_: any, i: number) => i !== index
                ),
              })

              formik.setErrors({
                ...formik.errors,
                agentLeaders: formik.errors.agentLeaders?.filter(
                  (_: any, i: number) => i !== index
                ),
              })
            }}
            className=' ms-2 mt-2 cursor-pointer'
            alt='delete-icon'
          />
        </div>
      ))}
      <CustomButton
        text='Add Agent Leader'
        className='btn-active-light-primary btn-light-primary fs-6 px-5 py-3 mt-4'
        onClick={() => {
          formik.setValues({
            ...formik.values,
            agentLeaders: [
              ...formik.values.agentLeaders,
              {leaderName: '', leaderCode: '', leaderStatus: true},
            ],
          })
        }}
        pathfromImages={'fitler-plus-blue.svg'}
      />
    </div>
  )
}
export default AgentLeader
